import { useRef, MutableRefObject } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Picture } from "@/components/wpl/image/src";
import { wacToken } from "@/libraries/design/foundations";

import { ActiveTeamDataProps } from "../hero-jira-cta-template";

const videoImgContainerStyles = css({
    width: "100%",
    aspectRatio: "16/9",
    borderRadius: "5px",
    border: `3px solid var(--Neutral-Light-200, ${wacToken(
        "color.neutral.light200"
    )})`,
    background: token("color.text.inverse")
});
const heroImageStyling = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: "100%",
        height: "100%",
        aspectRatio: "16/9",
        borderRadius: "5px",
        border: `3px solid var(--Neutral-Light-200, ${wacToken(
            "color.neutral.light200"
        )})`,
        background: token("color.text.inverse")
    }
    // eslint-enable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
});

export const ActiveMedia = (activeTeamData: ActiveTeamDataProps) => {
    const defaultVideoRef: MutableRefObject<HTMLVideoElement | null> =
        useRef(null);
    const { videoLink, heroImage, heroImageDimensions, id } = activeTeamData;
    // Note: videoLink may be undefined for TWC tabs
    const { imageWidth, imageHeight } = heroImageDimensions;
    const imageAltText = id ?? "";

    if (videoLink) {
        return (
            <video
                playsInline={true}
                muted={true}
                preload="auto"
                css={[videoImgContainerStyles]}
                poster={heroImage}
                autoPlay={true}
                ref={defaultVideoRef}
            >
                {heroImage}
                <source src={videoLink} type="video/mp4" />
            </video>
        );
    }

    return (
        <div css={heroImageStyling}>
            <Picture
                image={{
                    src: heroImage,
                    alt: imageAltText,
                    width: imageWidth,
                    height: imageHeight
                }}
                forceEagerLoad={true}
            />
        </div>
    );
};
